import React from "react";
import './Footer.css';


function Footer() {
    return(
        <div id="footer">
            <h4 className="bold">Quit-n-Time</h4>
            <p><span className="bold">Address:</span> 3353 Fort St, Wyandotte, MI 48192</p>
            <p id="last"><span className="bold">Phone:</span> (734) 246-4240</p>
        </div>
    )
}

export default Footer;
